import { render, staticRenderFns } from "./chart-data-table.vue?vue&type=template&id=ef2da666&scoped=true"
import script from "./chart-data-table.vue?vue&type=script&lang=js"
export * from "./chart-data-table.vue?vue&type=script&lang=js"
import style0 from "./chart-data-table.vue?vue&type=style&index=0&id=ef2da666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2da666",
  null
  
)

export default component.exports